'use client'
import { useRef, useCallback, useEffect, useState } from 'react'
import Spin from './Spin'

const InfiniteScroll = ({
  page,
  setPage,
  pageSize,
  loading = false,
  limitPagination = 40,
  totalResults,
  isOffset = false
}) => {
  const observer = useRef()
  const [hasMore, setHasMore] = useState(true)

  useEffect(() => {
    setHasMore(totalResults > page * pageSize)
  }, [page])

  const observedElement = useCallback(
    (node) => {
      if (loading) return
      if (observer.current) observer.current.disconnect()
      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && hasMore && page < limitPagination) {
          if (!isOffset) {
            setPage((prevPage) => prevPage + 1)
          } else {
            setPage(
              (prevOffset) => prevOffset + pageSize + (prevOffset === 0 ? 1 : 0)
            )
          }
        }
      })
      if (node) observer.current.observe(node)
    },
    [loading, hasMore, pageSize]
  )

  return (
    <div ref={observedElement}>
      {loading && (
        <div className="flex justify-center">
          <Spin color="text-blue" size="10" className="my-2 lg:my-8" />
        </div>
      )}
    </div>
  )
}

export default InfiniteScroll
